import { Action, NgxsOnInit, Selector, State, StateContext, Store } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { LoadAllBuildings, SelectDashboardBuilding } from './building.action';
import { BuildingItemDto, BuildingService } from '@artemis-software/wr-api';
import { AuthService } from '@services/auth.service';

interface BuildingStateModel {
  loading: boolean,
  selectedDashboardBuilding?: BuildingItemDto,
}

@State<BuildingStateModel>({
  name: 'buildings',
  defaults: {
    loading: false,
    selectedDashboardBuilding: undefined,
  },
})
@Injectable()
export class BuildingState implements NgxsOnInit{

  readonly store = inject(Store);
  readonly buildingService = inject(BuildingService);
  readonly authService = inject(AuthService);

  ngxsOnInit(): void {
    this.authService.loggedIn$.subscribe(() => {
      this.store.dispatch(new LoadAllBuildings());
    });
  }

  @Selector()
  static buildingsLoading(state: BuildingStateModel): boolean {
    return state.loading;
  }

  @Selector()
  static selectedDashboardBuilding(state: BuildingStateModel): BuildingItemDto | undefined {
    return state.selectedDashboardBuilding;
  }

  @Action(SelectDashboardBuilding)
  selectDashboardBuilding(ctx: StateContext<BuildingStateModel>, action: SelectDashboardBuilding): void {
    ctx.patchState({
      selectedDashboardBuilding: action.building,
    });
  }
}
